import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { TONE_TEXT, type OverviewTone } from '../overviewMeta';

type MetricRowProps = {
    /** Literal testid prefix, e.g. `net-working-capital-assets`. */
    slot: string;
    label: string;
    value: string;
    /**
     * Tint for the value. Only where the figure itself carries a verdict — a
     * liability is red because it is money owed, not because the row is
     * important. An untinted row is the default.
     */
    tone?: OverviewTone | null;
};

/** One `label … value` line, separated from the next. */
export const MetricRow: React.FC<MetricRowProps> = ({
    slot,
    label,
    value,
    tone,
}) => (
    <div
        className="flex items-center justify-between gap-3 border-b border-separator pb-2 last:border-b-0 last:pb-0"
        {...getNodeTestIdProp(`${slot}-row`)}
    >
        <span className="text-sm text-foreground">{label}</span>
        <span
            className={`text-sm font-medium ${tone ? TONE_TEXT[tone] : 'text-foreground'}`}
            {...getNodeTestIdProp(`${slot}-value`)}
        >
            {value}
        </span>
    </div>
);
